import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import MuiTabs from "@material-ui/core/Tabs";

const Tabs = withStyles({
  root: {
    minHeight: 36,
  },
  indicator: {
    backgroundColor: "transparent",
  }
})(props => <MuiTabs {...props} />);

export default Tabs;
